import { ReceivingRouteService } from 'common/data';
import { findParams } from 'core/utils';
import { BaseService } from 'core/services';

class ReceivingService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ReceivingRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default ReceivingService;



// WEBPACK FOOTER //
// ./src/common/data/services/ReceivingService.js